import { render, staticRenderFns } from "./GLYF_User_Favorites.vue?vue&type=template&id=33a28d44&scoped=true"
import script from "./GLYF_User_Favorites.vue?vue&type=script&lang=js"
export * from "./GLYF_User_Favorites.vue?vue&type=script&lang=js"
import style0 from "./GLYF_User_Favorites.vue?vue&type=style&index=0&id=33a28d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a28d44",
  null
  
)

export default component.exports